import {
  Typography,
  Icon,
  Modal,
  IconButton,
  Button,
  Input,
  Card,
  Textarea,
  Checkbox,
  Chip,
  Tooltip,
} from "@plum-xoxo/admin-dsm";
import TableElement from "../../components/styled/Table";
import React, { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import HorizontalStepper from "../../components/HorizontalStepper";
import ProfileService from "../../services/profileService";
import { useHistory, useLocation } from "react-router-dom";
import { app_path } from "config";
import { NotificationManager } from "react-notifications";
import theme from "../../theme";
const TopPanel = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 76px;
  background: ${(props) => props.theme.palette.light.c000};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 0.12);
`;
const BelowPanel = styled.div`
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 76px;
  background: ${(props) => props.theme.palette.light.c000};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.12);
`;
const StyledModal = styled(Modal).attrs()`
  background: ${(props) => props.theme.palette.background.tertiary};
`;
const StyledCard = styled(Card).attrs()`
  border: 1px solid ${(props) => props.theme.palette.light.c300};
`;
const VerifiedCard = styled(Card).attrs()`
  border: 1px solid ${(props) => props.theme.palette.light.c300};
  height: 291px;
`;
const StyledIcon = styled(Icon).attrs()`
  background: ${(props) => props.theme.palette.primary.c00};
  width: 48px;
  height: 48px;
  border-radius: 8px;
  padding: 10px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const StyledInput = styled(Input).attrs()`
  width: 403px;
`;
// const StyledTextarea = styled(Textarea).attrs()`
//   width: 700px;
// `;
// const StyledInput2 = styled(Input).attrs()`
//   width: 700px;
// `;
var steps = ["Add Domain", "Add DNS Records", "Verify Domain"];
const DomainAuthentication = () => {
  const history = useHistory();
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(true);
  const [isSendBtnDisabled, setIsSendBtnDisabled] = useState(
    "Hi, I am trying to authenticate our domain with Xoxoday, but I don’t have the ability to modify our DNS records. Can you help me add these records, so that i can complete the process?"
  );
  const [domain, setDomain] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [dns, setDns] = useState();
  const [dnsArray, setDnsArray] = useState([]);
  const [finlDnsArray, setFinlDnsArray] = useState([]);
  const [finlDns, setFinlDns] = useState([]);
  const [isEmailValid, setIsEmailValid] = useState("");
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isSenderDomainVerified, setIsSenderDomainVerified] = useState(false);
  const [isSenderDomainSuccess, setIsSenderDomainSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleCheckbox = (e) => {
    if (e.target.checked) {
      setIsCheckboxDisabled(false);
    } else {
      setIsCheckboxDisabled(true);
    }
  };
  const handleSendBtn = (e) => {
    setIsSendBtnDisabled(e.target.value);
  };
  let handleEmailChange = (email) => {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (re.test(email) && email.length > 0) {
      setIsEmailValid(email);
    } else {
      setIsEmailValid("");
    }
  };
  const handleSendMessage = () => {
    setIsLoading(true);
    ProfileService.triggerEmailSenderDomain({
      isEmailValid,
      isSendBtnDisabled,
    })
      .then((response) => {
        if (response?.data?.triggerEmailSenderDomain?.success) {
          setIsEmailSent(true);
          NotificationManager.success("Email to IT Admin sent successfully");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const handleAddDomain = (redirect) => {
    setIsLoading(true);
    ProfileService.addSenderDomain(redirect ? redirect : domain)
      .then((resp) => {
        if (resp?.data?.addSenderDomain?.success) {
          if (resp?.data?.addSenderDomain?.data?.dns.length != 0) {
            setDns(resp.data.addSenderDomain.data.dns);
            setActiveStep(1);
          }
        } else {
          NotificationManager.error(resp?.data?.addSenderDomain?.Message);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const handleVerifyDomain = () => {
    setIsLoading(true);
    ProfileService.verifySenderDomain()
      .then((response) => {
        if (response?.data?.verifySenderDomain?.success) {
          if (response?.data?.verifySenderDomain?.data?.dns.length != 0) {
            setFinlDns(response.data.verifySenderDomain.data.dns);
          }
          setIsSenderDomainVerified(true);
          setActiveStep(2);
          if (response?.data?.verifySenderDomain?.data?.status === 2) {
            setIsSenderDomainSuccess(true);
          } else {
            setIsSenderDomainSuccess(false);
          }
        } else {
          NotificationManager.error(
            response?.data?.verifySenderDomain?.Message
          );
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const handleReturnToComm = () => {
    history.push({
      pathname: `/${app_path}/accounts/platform-preferences`,
      activeTab: 4,
    });
  };
  const onClickHere = () => {
    const url =
      "https://helpcenter.xoxoday.com/docs/sending-email-authentication";
    window.open(url, "_blank");
  };

  useEffect(() => {
    const url = location?.state?.url;
    if (url?.length) {
      setRedirectUrl(url);
      setActiveStep(1);
      isValidDomain(url);
    }
  }, []);

  useEffect(() => {
    if (redirectUrl?.length) handleAddDomain(redirectUrl);
  }, [redirectUrl]);

  const options = {
    sort: false,
    selectableRows: "none",
    selectableRowsHeader: false,
    search: false,
    print: false,
    filter: false,
    download: false,
    viewColumns: false,
    pagination: false,
    customFooter: () => {
      return (
        <div className="mt-24 mb-40 d-flex flex-column align-items-center">
          <Typography color="dark" shade="c300">
            Not sure how to do this?{" "}
            <span className="cursor-pointer" onClick={onClickHere}>
              <Typography.ButtonText
                component="span"
                color="primary"
                shade="c02"
              >
                Check the documentation
              </Typography.ButtonText>
            </span>
          </Typography>
        </div>
      );
    },
  };
  let columns = [
    {
      name: "type",
      label: "Type",
      options: {
        customBodyRender: (value) => {
          return (
            <Typography component="div">
              <Typography component="span">{value}</Typography>
            </Typography>
          );
        },
      },
    },
    {
      name: "host",
      label: "Host",
      options: {
        customBodyRender: (value) => {
          return (
            <Typography component="div">
              <Typography component="span">{value}</Typography>
              <Tooltip tooltip="Copy host" placement="top" offset={[0, 5]}>
                <Icon
                  color="dark"
                  shade="c100"
                  iconName="PlumCopy"
                  onClick={() => {
                    navigator.clipboard.writeText(value);
                    NotificationManager.success("Host copied!", "", 1000);
                  }}
                  padding="2px"
                  size="s"
                />
              </Tooltip>
            </Typography>
          );
        },
      },
    },
    {
      name: "value",
      label: "Value",
      options: {
        customBodyRender: (value) => {
          return (
            <Typography component="div">
              <Typography component="span">{value}</Typography>
              <Tooltip tooltip="Copy value" placement="top" offset={[0, 5]}>
                <Icon
                  color="dark"
                  shade="c100"
                  iconName="PlumCopy"
                  onClick={() => {
                    navigator.clipboard.writeText(value);
                    NotificationManager.success("Value copied!", "", 1000);
                  }}
                  padding="2px"
                  size="s"
                />
              </Tooltip>
            </Typography>
          );
        },
      },
    },
  ];
  let Finlcolumns = [
    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (value) => {
          return (
            <Chip
              hover={false}
              color="custom"
              backgroundColor={value.valid === 0 ? "red" : "green"}
              backgroundShade="c000"
              textColor={value.valid === 0 ? "red" : "green"}
              textShade="c200"
              label={
                value.valid === 0 ? (
                  <Typography component="div">
                    <Typography component="span">Failed</Typography>{" "}
                    <Tooltip
                      width={279}
                      tooltip={value.reason}
                      placement="right"
                      offset={[0, 10]}
                    >
                      <Icon iconName="Info" color="red" shade="c200" size="s" />
                    </Tooltip>
                  </Typography>
                ) : (
                  "Success"
                )
              }
              style={{
                height: "24px",
              }}
              radius={8}
              variant="fill"
            />
          );
        },
      },
    },
    {
      name: "type",
      label: "Type",
      options: {
        customBodyRender: (value) => {
          return (
            <Typography component="div">
              <Typography component="span">{value}</Typography>
            </Typography>
          );
        },
      },
    },
    {
      name: "host",
      label: "Host",
      options: {
        customBodyRender: (value) => {
          return (
            <Typography component="div">
              <Typography component="span">{value}</Typography>
              <Tooltip tooltip="Copy Host" placement="top" offset={[0, 5]}>
                <Icon
                  color="dark"
                  shade="c100"
                  iconName="PlumCopy"
                  onClick={() => {
                    navigator.clipboard.writeText(value);
                    NotificationManager.success("Host copied!", "", 1000);
                  }}
                  padding="2px"
                  size="s"
                />
              </Tooltip>
            </Typography>
          );
        },
      },
    },
    {
      name: "value",
      label: "Value",
      options: {
        customBodyRender: (value) => {
          return (
            <Typography component="div">
              <Typography component="span">{value}</Typography>
              <Tooltip tooltip="Copy Value" placement="top" offset={[0, 5]}>
                <Icon
                  color="dark"
                  shade="c100"
                  iconName="PlumCopy"
                  onClick={() => {
                    navigator.clipboard.writeText(value);
                    NotificationManager.success("Value copied!", "", 1000);
                  }}
                  padding="2px"
                  size="s"
                />
              </Tooltip>
            </Typography>
          );
        },
      },
    },
  ];
  const isValidDomain = (inputText) => {
    setDomain(inputText);
    const domainRegExp = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i;
    const isValid = domainRegExp.test(inputText);

    if (isValid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };
  let dnsListArray = [];
  useEffect(() => {
    if (dns) {
      Object.values(dns).map((item) => {
        let tempArray = [];
        tempArray.push(item?.type?.toUpperCase());
        tempArray.push(item?.host);
        tempArray.push(item?.data);
        dnsListArray.push(tempArray);
      });
      setDnsArray(dnsListArray);
    }
  }, [dns]);
  useEffect(() => {
    if (finlDns) {
      Object.values(finlDns).map((item) => {
        let tempArray = [];
        tempArray.push({ valid: item.valid, reason: item.reason });
        tempArray.push(item.type.toUpperCase());
        tempArray.push(item.host);
        tempArray.push(item.data);
        dnsListArray.push(tempArray);
      });
      setFinlDnsArray(dnsListArray);
    }
  }, [finlDns]);

  const handleChangeStep = (step) => {
    setActiveStep(step);
  };

  return (
    <div className="contentWrapper">
      <StyledModal isOpen={true} fullScreen padding={false}>
        <div className="pt-74 pb-74 pl-40 pr-40">
          <div className="mt-40">
            <HorizontalStepper
              activeStep={activeStep}
              steps={steps}
              onChangeStep={handleChangeStep}
            />
          </div>
          {activeStep === 0 && (
            <div className="mb-24">
              <Typography.H1 className="mt-24 mb-24" color="dark" shade="c300">
                Authenticate your Domain
              </Typography.H1>
              <StyledCard spaceAround={6} shadow={false}>
                <div className="d-flex">
                  <div className="mr-20">
                    <StyledIcon
                      color="primary"
                      shade="c03"
                      iconName="Global"
                      size="22"
                    />
                  </div>
                  <div>
                    <Typography.H2 color="dark" shade="c300">
                      Add your Domain
                    </Typography.H2>
                    <Typography.HelperText color="dark" shade="c200">
                      Send your rewards through this domain
                    </Typography.HelperText>
                  </div>
                </div>
                <div className="mt-24">
                  <StyledInput
                    onChange={(e) => isValidDomain(e.target.value)}
                    type="email"
                    value={domain}
                    placeholder="Enter your domain eg: company.com"
                  ></StyledInput>
                </div>
              </StyledCard>
            </div>
          )}
          {activeStep === 1 && (
            <div className="mb-24">
              <Typography.H1 className="mt-24 mb-24" color="dark" shade="c300">
                Add Records to your DNS
              </Typography.H1>{" "}
              {dnsArray.length > 0 && (
                <TableElement
                  className="px-4 my-16 box"
                  title={""}
                  columns={columns}
                  options={options}
                  data={dnsArray}
                />
              )}
              <StyledCard className="mt-24" spaceAround={6} shadow={false}>
                <div className="d-flex justify-content-between">
                  <div>
                    <Typography.H3 color="dark" shade="c300">
                      Send to IT Admin
                    </Typography.H3>
                    <Typography className="mb-0" color="dark" shade="c200">
                      Send DNS records to your IT Admin through email
                    </Typography>
                  </div>
                  <div className="d-flex mr-24">
                    <Button
                      disabled={
                        isEmailValid.length === 0 ||
                        isSendBtnDisabled.length === 0
                      }
                      onClick={!isEmailSent && handleSendMessage}
                      variant={isEmailSent ? "plain" : "outlined"}
                      color="primary"
                    >
                      {isEmailSent ? "Sent" : "Send"}
                    </Button>
                  </div>
                </div>
                <div className="mt-24">
                  <Input
                    onChange={(e) => {
                      handleEmailChange(e.target.value);
                    }}
                    className="mr-24"
                    label="Email Address"
                    placeholder="johndoe@abc.com"
                  ></Input>
                </div>
                <div className="mt-16">
                  <Textarea
                    onChange={(e) => {
                      handleSendBtn(e);
                    }}
                    className="mr-24"
                    limit="250"
                    label="Message"
                    value={isSendBtnDisabled}
                  ></Textarea>
                </div>
              </StyledCard>
              <div className="mt-24">
                <div className="d-flex">
                  <Checkbox
                    onChange={(e) => {
                      handleCheckbox(e);
                    }}
                    label={
                      <Typography color="dark" shade="c200" className="mb-0">
                        Please verify that your records have been added
                      </Typography>
                    }
                    className="mr-8"
                  ></Checkbox>
                </div>
              </div>
            </div>
          )}
          {activeStep === 2 && (
            <div className="mb-24">
              {isSenderDomainSuccess ? (
                <>
                  <Typography.H1
                    className="mt-24 mb-24"
                    color="dark"
                    shade="c300"
                  >
                    Verification Successful
                  </Typography.H1>{" "}
                  <VerifiedCard spaceAround={6} shadow={false}>
                    <div className="d-flex flex-column align-items-center">
                      <div className="mt-56">
                        <Icon
                          color="success"
                          iconName="Confirm"
                          onClick={() => {}}
                          shade="c03"
                          size="xl"
                        />
                      </div>
                      <Typography.H3 className="mt-24">
                        It Worked!
                      </Typography.H3>
                      <Typography className="mt-12 mb-0">
                        Your authenticated domain for{" "}
                        {redirectUrl?.length ? redirectUrl : domain} was
                        verified
                      </Typography>
                      <div className="mt-20 mb-64">
                        <Button
                          onClick={handleReturnToComm}
                          variant="fill"
                          color="primary"
                        >
                          Return to Communication
                        </Button>
                      </div>
                    </div>
                  </VerifiedCard>
                </>
              ) : (
                <>
                  <Typography.H1
                    className="mt-24 mb-24"
                    color="dark"
                    shade="c300"
                  >
                    Verify your Domain
                  </Typography.H1>{" "}
                  {dnsArray.length > 0 && (
                    <TableElement
                      className="px-4 my-16 box"
                      title={""}
                      columns={Finlcolumns}
                      options={options}
                      data={finlDnsArray}
                    />
                  )}
                </>
              )}
            </div>
          )}
        </div>

        <TopPanel className="d-flex justify-content-between">
          <Typography.H3 className="ml-40" color="dark" shade="c300">
            Sender Domain Authentication
          </Typography.H3>
          <IconButton
            variant="plain"
            size={20}
            onClick={() => {}}
            className="mr-40"
          >
            <Icon
              iconName="Close"
              color="text"
              shade="c01"
              size={16}
              onClick={handleReturnToComm}
            />
          </IconButton>
        </TopPanel>
        {!isSenderDomainSuccess ? (
          <BelowPanel>
            {" "}
            {activeStep != 2 ? (
              <Button
                variant="plain"
                color="primary"
                className="mr-20"
                onClick={() => {
                  setActiveStep(0);
                  setIsCheckboxDisabled(true);
                  setIsEmailSent(false);
                  if (activeStep === 0) {
                    handleReturnToComm();
                  }
                }}
              >
                {" "}
                {activeStep == 0 ? "Cancel" : "Back"}
              </Button>
            ) : (
              <Button
                variant="plain"
                color="primary"
                className="mr-20"
                onClick={() => {
                  handleReturnToComm();
                  setIsCheckboxDisabled(true);
                }}
              >
                Cancel
              </Button>
            )}
            {activeStep != 2 ? (
              <div className="mr-40">
                <Button
                  loading={isLoading}
                  onClick={() => {
                    if (activeStep == 0) {
                      handleAddDomain();
                    } else {
                      handleVerifyDomain();
                    }
                  }}
                  variant="fill"
                  color="primary"
                  disabled={activeStep == 0 ? isDisabled : isCheckboxDisabled}
                >
                  {activeStep == 0 ? "Save and Proceed" : "Verify"}
                </Button>
              </div>
            ) : (
              <div className="mr-40">
                <Button
                  loading={isLoading}
                  onClick={() => {
                    handleVerifyDomain();
                  }}
                  variant="fill"
                  color="primary"
                  disabled={activeStep == 0 ? isDisabled : isCheckboxDisabled}
                >
                  Verify
                </Button>
              </div>
            )}
          </BelowPanel>
        ) : null}
      </StyledModal>
    </div>
  );
};

export default DomainAuthentication;
